// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"167":"spareparts","571":"settings","831":"loginscreen"}[chunkId] + "." + {"167":"0f1b90e1","571":"0d9e81a3","831":"6fed5ebe"}[chunkId] + ".css";
};